import { useState, useEffect } from "react";

const Banner = ({
  Content = "",
  displayDuration = 10000,
  interval = 2 * 60 * 1000,
  className = "",
}) => {
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    const triggerBanner = () => {
      setShowBanner(true);
      setTimeout(() => {
        setShowBanner(false);
      }, displayDuration);
    };

    triggerBanner(); // Show initially
    const showInterval = setInterval(triggerBanner, interval);

    return () => clearInterval(showInterval);
  }, [displayDuration, interval]);

  return (
    <div
      className={`text-center p-1 ml-2 bg-yellow-100 text-yellow-800 font-medium z-50 transition-opacity duration-1000 ease-in-out ${
        showBanner ? "opacity-100" : "opacity-0 pointer-events-none"
      } ${className}`}
    >
      {Content}
    </div>
  );
};

export default Banner;
